import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';

import {
  CHECKINGACCOUNT,
  CHECKINGACCOUNT_REFRESH_RESOURCE,
  CHECKINGACCOUNT_FETCH_BALANCES,
  CHECKINGACCOUNT_FETCH_BALANCES_FINISHED,
  CHECKINGACCOUNT_FETCH_INCOME_STATEMENT_FINISHED,
  CHECKINGACCOUNT_FETCH_INCOME_STATEMENT
} from './checkingAccountActions';

const checkingAccountReducer = createResourceReducer(
  CHECKINGACCOUNT,
  [],
  {
    [CHECKINGACCOUNT_REFRESH_RESOURCE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false
      }));
    },

    [CHECKINGACCOUNT_FETCH_BALANCES](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: true
      }));
    },

    [CHECKINGACCOUNT_FETCH_BALANCES_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        balances: action.payload.data.result,
        loading: false
      }));
    },

    [CHECKINGACCOUNT_FETCH_INCOME_STATEMENT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: true
      }));
    },

    [CHECKINGACCOUNT_FETCH_INCOME_STATEMENT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        incomeStatements: action.payload.data.result,
        loading: false,
        loaded: true
      }));
    }
  },
  (state, action) => ({ loading: false })
);

export default checkingAccountReducer;
